import { DEFAULT_DESCRIPTION, SITE_NAME, SITE_ORIGIN } from './siteConfig'

export const routeSeo = {
  '/': {
    title: `${SITE_NAME} — Jamaica Tours, Shuttles & Car Rental`,
    description: DEFAULT_DESCRIPTION,
    h1: 'Welcome Traveler',
  },
  '/tours': {
    title: `Custom Jamaica Tours | ${SITE_NAME}`,
    description:
      'Browse scheduled island tours and book a custom Reggae Wheels tour. Day trips and routes serving Montego Bay, Ocho Rios, and Negril.',
    h1: 'Jamaica Tours',
  },
  '/tours/book': {
    title: `Book a Custom Tour | ${SITE_NAME}`,
    description: 'Reserve a custom Jamaica tour with pick-up, destinations, and group size. Sign in to complete your booking.',
    h1: 'Book Your Custom Tour',
  },
  '/trips': {
    title: `Current Trips Schedule | ${SITE_NAME}`,
    description:
      'See upcoming Reggae Wheels trips around Jamaica — social rides and scheduled departures from Discovery Bay and north-coast hubs.',
    h1: 'Trips Schedule',
  },
  '/rentals': {
    title: `Rent a Car in Jamaica | ${SITE_NAME}`,
    description:
      'Browse rental vehicles for self-drive exploration of Jamaica. Discovery Bay base with access to Montego Bay, Ocho Rios, and Negril.',
    h1: 'Rent a Car',
  },
  '/shuttle': {
    title: `Airport & Hotel Shuttle | ${SITE_NAME}`,
    description:
      'Montego Bay (MoBay) airport shuttle and north-coast hotel transfers. Group-friendly bus shuttle service in Jamaica.',
    h1: 'Shuttle Service',
  },
  '/chauffeuring': {
    title: `Chauffeur Service Jamaica | ${SITE_NAME}`,
    description:
      'Private chauffeur-driven transport in Jamaica — Discovery Bay, Montego Bay, Ocho Rios, and Negril routes.',
    h1: 'Chauffeur Service',
  },
  '/arrangements': {
    title: `Special Travel Arrangements | ${SITE_NAME}`,
    description:
      'Custom group transport and special arrangements for events and tours across Jamaica.',
    h1: 'Special Arrangements',
  },
  '/events': {
    title: `Events Transport | ${SITE_NAME}`,
    description: 'Event shuttle and group transport planning with Reggae Wheels in Jamaica.',
    h1: 'Events',
  },
  '/shopping': {
    title: `Shopping Trips | ${SITE_NAME}`,
    description: 'Organized shopping and market trips around Jamaica with Reggae Wheels transport.',
    h1: 'Shopping',
  },
  '/delivery': {
    title: `Delivery & Courier Runs | ${SITE_NAME}`,
    description: 'Local delivery and courier-style transport requests in the Discovery Bay and north-coast area.',
    h1: 'Delivery',
  },
  '/about-us': {
    title: `About Us | ${SITE_NAME}`,
    description: 'Learn about Reggae Wheels — Jamaica tours, shuttles, and rental transport based in Discovery Bay.',
    h1: 'About Us',
  },
  '/login': {
    title: `Log In | ${SITE_NAME}`,
    description: 'Sign in to your Reggae Wheels account to book tours and manage reservations.',
    h1: 'Log In',
  },
  '/signup': {
    title: `Sign Up | ${SITE_NAME}`,
    description: 'Create a Reggae Wheels account to book tours, trips, and rentals in Jamaica.',
    h1: 'Sign Up',
  },
}

export function resolveSeo(pathname) {
  const path = pathname.replace(/\/$/, '') || '/'
  if (routeSeo[path]) {
    return { ...routeSeo[path], canonical: `${SITE_ORIGIN}${path === '/' ? '/' : path}` }
  }
  return {
    title: SITE_NAME,
    description: DEFAULT_DESCRIPTION,
    h1: SITE_NAME,
    canonical: `${SITE_ORIGIN}${path}`,
  }
}
